require('lazysizes'); // works with .lazyload and .lazyloaded classes

import {pageInfo} from 'modules/models/PageInfo';
import {userInfo} from 'modules/models/UserInfo';
import getUserInfo from 'modules/utilities/getUserInfo';
import {AnalyticsTrackingService} from 'modules/services/AnalyticsTrackingService';

require('./common-styles.scss');
require('modules/shared/footer/footer');

export {pageInfo};
export {userInfo};
export {getUserInfo};
export {AnalyticsTrackingService};



// WEBPACK FOOTER //
// ./resources/modules/shared/common-libs.ts